import { render } from "./article-share-item.vue?vue&type=template&id=62f8b9fd"
import script from "./article-share-item.vue?vue&type=script&lang=js"
export * from "./article-share-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__